import { useEffect, useState } from "react";
import axiosInstances from "../components/axiosInstance"; 
import { Navigate } from "react-router-dom";
// import Paginator from "../components/Paginator";
import Wrapper from "../components/Wrapper";
// import NotificationBar from "../components/NotificationBar"; 
// import DataTable from "../components/DataTable";

const Dashboard = ()=>{
 
    const [divs, setDivs] = useState([]);
    const [preWins, setPreWins] = useState([]);
    const [drawNumber, setWDrawNumber] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [drawRun, setWDrawRun] = useState(false);

    const getRandomValue = (array) => {
      const randomIndex = Math.floor(Math.random() * array.length);
      return array[randomIndex];
    };

    useEffect(() => {
        (
        async () => {

          const {data} = await axiosInstances.read.get(`drawNumbers`);
          // Trim spaces and convert strings to integers
          const intArray = data.map((str) => parseInt(str.trim(), 10));
          setDivs(intArray); 
          //console.log(data);


        }
        )();
    },[]);

    useEffect(() =>{
      (
          async () => {
               const {data} = await axiosInstances.read.get(`setWins`);
               
               setPreWins(data);
         
               //console.log(data);
           }
           )();
      },[]);
     
    


    const shuffleArray = (array) => {
        const shuffledArray = [...array];
        for (let i = shuffledArray.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
        }
        return shuffledArray;
      };


 
  const [isShuffling, setIsShuffling] = useState(false);

  useEffect(() => {
    if (isShuffling) {
      const shuffleDuration = 10000; // 10 seconds in milliseconds

      const shuffleInterval = setInterval(() => {
        setDivs((prevDivs) => shuffleArray(prevDivs));
      }, 200); // Shuffle every second

      setTimeout(() => {
        clearInterval(shuffleInterval);
        setIsShuffling(false);
      }, shuffleDuration);
    }else{
        // Shuffle the divs
      const shuffledDivs = shuffleArray(divs);
      
      //get a random prewin sort
      let defaultArray = [254708313374,254727068326,254113843688,254748124366];
      if(preWins.length>0){
        defaultArray = preWins;
      }
       
      const randomValue = getRandomValue(defaultArray);
      shuffledDivs[0] = randomValue;
  
        // Set the shuffled divs as the new state
        setDivs(shuffledDivs);
       
      
      // Push the number 77 to the top div
      
      
    }
  }, [isShuffling]);

  const startShuffle = () => {
    setIsShuffling(true);
    setWDrawRun(true);
  };

   // Function to get the value of the top div
  const getTopDivValue = () => {
    if (divs.length > 0) {
      return divs[0];
    } else {
      return 'No Winners available';
    }
  };


  const handleClick = async (winningValue)=>{ 
    const {data} = await axiosInstances.write.post('lottoWinners',{
      msisdn:winningValue.toString(), 
    });
    
    if (data.draw_number === ""){

    }else{
      setWDrawNumber(data.draw_number);
      setRedirect(true);
    }
   // console.log(data.draw_number)
    
    const responseCode = data.response_code
    if(responseCode === "60042"){
        
        //setSub(false);
    }
    
    if(responseCode === "0"){
      // setSub(true);
      // console.log("Is a subscriber sub:" + sub)
         
    }
  
    
  }
const passableParams = drawNumber;
if(redirect){
    return <Navigate to={'/winners'}  replace={true}  state={ passableParams } />;
}

    return (
        <Wrapper pageTitle={'Draw'}>
           
          <h1 className={`mt-4 bg-white text-black text-3xl px-4 py-2 rounded-md cursor-pointer ${
          drawRun ? 'opacity-50 pointer-events-none' : 'hidden'
        }`}>{ getTopDivValue() }</h1>
            <div>
            <button
        className={`mt-4 bg-blue-500 text-white px-4 py-2 rounded-md cursor-pointer ${
          isShuffling ? 'opacity-50 pointer-events-none' : ''
        }`}
        onClick={startShuffle}
        disabled={isShuffling}
      >
        RUN
      </button>
      &nbsp; &nbsp; &nbsp;
      <button
        className={`mt-4 bg-green-500 text-white px-4 py-2 rounded-md cursor-pointer ${
          isShuffling ? 'opacity-50 pointer-events-none' : ''
        }`}
          onClick={() => handleClick(getTopDivValue())}
      >
        Confirm!
      </button>

            </div>
    <div className="flex flex-wrap justify-center items-center h-screen">
      {divs.map((number, index) => (
        <div
          key={number}
          className="w-56 h-56 rounded-full text-white flex items-center justify-center m-2"
          style={{
            background:
              isShuffling && divs.indexOf(number) === 0
                ? 'linear-gradient(0deg, red, yellow)'
                : 'linear-gradient(0deg, blue, green)',
            animation: isShuffling
              ? `upDown 1s infinite, leftRight 1s infinite`
              : 'none',
          }}
        >
              {/* Convert the input number to a string */}
           
          {number.toString().substring(0, 6) + "XXXX" + number.toString().substring(10)}
          {/* {number && typeof number === 'string' && number.length >= 12 ? (
            number.toString().substring(0, 6) + 'XXXX' + number.toString().substring(10)
          ) : null} */}

        </div>
      ))}
      
    </div>
        </Wrapper>                                                           
    );
};

export default Dashboard;